import axios from "axios";
import { baseUrl } from "@/config/baseUrl";
export const getInstance = ({ app_name, model_name }) => {
    let orm = {}
    orm.appName = app_name;
    orm.modelName = model_name;
    let proxy = new Proxy(orm, {
        get(target, key) {
            return async ({ params, post }) => {
                let res = await axios.post(`${baseUrl}${orm.appName}/${orm.modelName}/${key}`, post ? post : {}, { params: params });
                return res.data.data;
            }
        }
    })
    return proxy;
}